export const INVOICE_TOUR_DEVTOOLS_STORE_NAME = 'invoiceVirtualTour'

export const INVOICE_TOUR_STORE_ACTIONS = {
  startTour: 'invoiceVirtualTour/startTour',
  goToStep: 'invoiceVirtualTour/goToStep',
  stopTour: 'invoiceVirtualTour/stopTour',
} as const
